

import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Card from "@mui/material/Card";
import Slide from "@mui/material/Slide";
import MDBox from "components/MDBox";
import SearchCompetitorProfile from "../../../platform-scout/SearchCompetitorProfile";

function SearchCompetitorModal({ open, onClose }) {
  const [showCard, setShowCard] = useState(false);

  // Trigger slide in/out based on `open`
  useEffect(() => {
    if (open) {
      setShowCard(true);
    } else {
      // Delay unmount so slide-out can complete
      const timeout = setTimeout(() => setShowCard(false), 300); // match Slide duration
      return () => clearTimeout(timeout);
    }
  }, [open]);

  const handleCloseClick = () => {
    setShowCard(false); // Triggers slide-out
    setTimeout(onClose, 300); // Delay actual close to match slide-out
  };

  return (
    <Backdrop
      open={open || showCard} // Keep Backdrop open during slide out
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        transition: "opacity 0.3s ease-in-out",
      }}
    >
      <Slide direction="up" in={showCard} mountOnEnter unmountOnExit>

        <Card
          sx={{
            width: "95%",
            maxWidth: 1000,
            maxHeight: "95%",
            overflowY: "auto",
            borderRadius: 2,
            position: "relative",
            padding: 3,
          }}
        >
          <IconButton
            onClick={handleCloseClick}
            sx={{ position: "absolute", top: 0, right: 0, zIndex: 1201 }}
          >
            <CloseIcon />
          </IconButton>

          <MDBox pt={4}>
            <SearchCompetitorProfile isWorkflow={true} />
          </MDBox>
        </Card>
      </Slide>
    </Backdrop>
  );
}

export default SearchCompetitorModal;
